function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2729_88442)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.00001 6.375L10.587 10.191L14.706 10.521L11.568 13.209L12.5265 17.229L9.00001 15.075L5.47351 17.229L6.43201 13.209L3.29401 10.521L7.41301 10.191L9.00001 6.375ZM9.00001 10.2802L8.44576 11.613L7.00876 11.7277L8.10376 12.666L7.76851 14.0693L9.00001 13.317L10.2308 14.0693L9.89626 12.6667L10.9905 11.7277L9.55426 11.613L9.00001 10.2802ZM6.00001 1.5V8.25H4.50001V1.5H6.00001ZM13.5 1.5V8.25H12V1.5H13.5ZM9.75001 1.5V5.25H8.25001V1.5H9.75001Z",
  fill: "#07003D",
  fillOpacity: 0.3
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2729_88442"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white"
})));

var SvgClaimTypeIcon = function SvgClaimTypeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClaimTypeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/claimTypeIcon.207faa94.svg";
export { ForwardRef as ReactComponent };